import FinderViewBase from '../../FinderViewBase/FinderViewBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TranslationsFinderHome.html?raw';
import on from 'dojo/on';
import "../WebTranslationsTypes";
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import TranslationsEditor from '../TranslationsEditor/TranslationsEditor';

class TranslationsFinderHome extends compose(FinderViewBase) {
    templateString: any = template;

    entityListAttributeName = "entitylist";
    loadFilterDatatUrl = "WebTranslations/GetTranslationsList";
    loadFinderConfigUrl = "WebTranslations/GetFilterpanelOptions";
    btnContinueLabelText = (this as any).translations["General_BtnSubmitNext"];
    btnSubmitLabelText = (this as any).translations["General_Search"];



    tableFormatter(cell: StaticTable.StaticTableCell<any>) {

        let node = cell.contentnode;
        let entity: WebTranslation_Entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let rowNode = node.parentNode.parentNode;

        this.UiModder.domClass.add(rowNode, "mds-hover-border");
        this.UiModder.domStyle.set(node.parentElement.parentElement, "cursor", "default");

        switch (colName) {
            case "actions":
                this.UiModder.domClass.add(node, "w3-center");

                var btn = this.UiModder.domConstruct.create("button", {
                    "class": "mds-button-base round w3-center sL3 mds-hover-border-orange w3-large",
                    "onclick": lang.hitch(this, this._onClick_ShowEditBtn, entity.ID, rowNode),
                    "title": this.translations["General_ShowEdit"],
                }, node);

                this.UiModder.domConstruct.create("i", { "class": "fas fa-edit" }, btn);
                return true;
                break;
            default:
                return false;
                break;
        }
    }

    // was wollen wir mit den FilterDaten anstellen
    processFilterListResponse_callback(): void {

        // z.B. gleich eine Tabelle kreieren
        //let tableLayoutOption = this.getFilterOptionByName("tableLayouts");
        var selectedLayout: string = "translation";//<string>tableLayoutOption.data.value;


        let table = this.createTable(
            "translationTable",
            this.resultContainer,
            selectedLayout,
            this.lastResponse.entitylist,
            lang.hitch(this, this.tableFormatter)
        );
    }

    loadTranslationData(entityId: string, rowNode): void {

        let requestUrl = window.appRoot + "WebTranslations/LoadTranslationData";
        this.StandbyStart(rowNode);

        this.RequestManager.post(
            requestUrl,
            {
                entityId: entityId
            },
            lang.hitch(this, this._onLoadTranslationDataResponse),
            lang.hitch(this, this._onLoadTranslationDataError),
            false // sync
        );
    }

    _onLoadTranslationDataResponse(data: WebTranslation_Entity): void {

        console.debug("data", data);

        let dlg = new GenericDialog();
        let form = new TranslationsEditor();

        dlg.setCloseOnEscape(true);
        dlg._setCloseBtnAttr(true);
        dlg._setTopCloseBtnAttr(true);
        dlg.closeOnEscape = true;
        dlg.closeOnEnter = false;
        dlg.destroyOnClose = true;

        dlg.addButton("saveBtn", "Save", lang.hitch(form, form._onClick_saveBtn), null, "w3-margin-left mds-button-base w3-padding round mds-hover-bright w3-disabled accentBG", "fas fa-save", false, "last");
        on(form, "Translation_Save", lang.hitch(this, this.closeFormAndRefresh, dlg));

        form.saveBtnNode = dlg.getButtonByName("saveBtn").node;

        form.loadCatalogEntityData(data);
        dlg._setHeaderAttr(this.translations["TranslationEditor_Header_Main"]);

        form.placeAt(dlg.textNode);
        dlg.show();

        this.StandbyStop();
    }

    closeFormAndRefresh(dlg: MdsLax<InstanceType<typeof GenericDialog>>): void {

        dlg.close();
        this.reload();
    }

    _onClick_ShowEditBtn(entityId: string, rowNode): void {

        this.loadTranslationData(entityId, rowNode);
    }

    _onLoadTranslationDataError(err): void {

        let errDlg = new GenericDialog();

        errDlg.destroyOnClose = true;
        this.UiModder.domClass.add(errDlg.contentContainer, "warningBG")
        this.UiModder.domStyle.set(errDlg.modalDlgContentNode, "width", "800px");
        this.UiModder.domStyle.set(errDlg.modalDlgContentNode, "margin-top", "100px");

        errDlg.show(err.Message, "Error!", null, "fas fa-exclamation-triangle", "close");

        this.StandbyStop();
    }

    

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(TranslationsFinderHome);